import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {
  @Input() showFiscalData: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  get getCurrentYear() {
    return new Date().getFullYear()
  }

}
